import React from 'react';
import { motion } from 'framer-motion';
import { Card } from './ui/Card';
import { Download, Calendar, Filter } from 'lucide-react';
export function AnalyticsPreview() {
  return <section className="py-24 bg-[#FAFAFA]" data-id="element-1">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-3">
          <h2 className="text-3xl sm:text-4xl font-bold text-slate-900 mb-4" data-id="element-4">
            Data-Driven Decisions
          </h2>
          <p className="text-lg text-slate-600" data-id="element-5">
            Comprehensive reporting tools to track ROI, identify trends, and
            optimize your wellness program strategy.
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.7
      }} data-id="element-6">
          <Card className="max-w-5xl mx-auto shadow-xl border-slate-200" noPadding data-id="element-7">
            {/* Toolbar */}
            <div className="border-b border-slate-100 p-4 flex flex-wrap gap-4 justify-between items-center bg-white" data-id="element-8">
              <div className="flex gap-2" data-id="element-9">
                <button className="flex items-center px-3 py-2 text-sm font-medium text-slate-600 bg-slate-50 rounded-lg border border-slate-200 hover:bg-slate-100" data-id="element-10">
                  <Calendar className="w-4 h-4 mr-2" data-id="element-11" /> Last 30 Days
                </button>
                <button className="flex items-center px-3 py-2 text-sm font-medium text-slate-600 bg-slate-50 rounded-lg border border-slate-200 hover:bg-slate-100" data-id="element-12">
                  <Filter className="w-4 h-4 mr-2" data-id="element-13" /> Filter
                </button>
              </div>
              <button className="flex items-center px-3 py-2 text-sm font-medium text-white bg-[#0A7E8C] rounded-lg hover:bg-[#086A76]" data-id="element-14">
                <Download className="w-4 h-4 mr-2" data-id="element-15" /> Export Report
              </button>
            </div>

            {/* Dashboard Content */}
            <div className="p-6 bg-slate-50/50" data-id="element-16">
              <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 mb-6" data-id="element-17">
                {/* Line Chart Area */}
                <div className="lg:col-span-2 bg-white p-6 rounded-xl border border-slate-100 shadow-sm" data-id="element-18">
                  <h3 className="text-sm font-bold text-slate-900 mb-6" data-id="element-19">
                    Check-in Trends
                  </h3>
                  <div className="h-64 flex items-end gap-4 relative" data-id="element-20">
                    {/* Grid lines */}
                    <div className="absolute inset-0 flex flex-col justify-between pointer-events-none" data-id="element-21">
                      {[0, 1, 2, 3, 4].map(i => <div key={i} className="w-full h-px bg-slate-100" data-id="element-22" />)}
                    </div>

                    {/* Chart Line (SVG) */}
                    <svg className="absolute inset-0 w-full h-full overflow-visible" preserveAspectRatio="none" data-id="element-23">
                      <path d="M0,200 C50,180 100,220 150,150 C200,80 250,120 300,100 C350,80 400,40 450,60 C500,80 550,20 600,40" fill="none" stroke="#FF6B35" strokeWidth="3" vectorEffect="non-scaling-stroke" data-id="element-24" />
                      <path d="M0,200 C50,180 100,220 150,150 C200,80 250,120 300,100 C350,80 400,40 450,60 C500,80 550,20 600,40 V256 H0 Z" fill="url(#gradient)" opacity="0.1" data-id="element-25" />
                      <defs data-id="element-26">
                        <linearGradient id="gradient" x1="0%" y1="0%" x2="0%" y2="100%" data-id="element-27">
                          <stop offset="0%" stopColor="#FF6B35" data-id="element-28" />
                          <stop offset="100%" stopColor="#FF6B35" stopOpacity="0" data-id="element-29" />
                        </linearGradient>
                      </defs>
                    </svg>
                  </div>
                </div>

                {/* Pie Chart Area */}
                <div className="bg-white p-6 rounded-xl border border-slate-100 shadow-sm flex flex-col" data-id="element-30">
                  <h3 className="text-sm font-bold text-slate-900 mb-6" data-id="element-31">
                    Program Distribution
                  </h3>
                  <div className="flex-1 flex items-center justify-center relative" data-id="element-32">
                    <div className="w-40 h-40 rounded-full border-[16px] border-[#0A7E8C] border-r-[#FF6B35] border-b-[#FF6B35] transform -rotate-45" data-id="element-33" />
                    <div className="absolute text-center" data-id="element-34">
                      <div className="text-2xl font-bold text-slate-900" data-id="element-35">
                        85%
                      </div>
                      <div className="text-xs text-slate-500" data-id="element-36">Utilization</div>
                    </div>
                  </div>
                  <div className="mt-6 space-y-2" data-id="element-37">
                    <div className="flex items-center justify-between text-sm" data-id="element-38">
                      <div className="flex items-center gap-2" data-id="element-39">
                        <div className="w-3 h-3 rounded-full bg-[#0A7E8C]" data-id="element-40" />
                        <span className="text-slate-600" data-id="element-41">Gym Memberships</span>
                      </div>
                      <span className="font-medium text-slate-900" data-id="element-42">65%</span>
                    </div>
                    <div className="flex items-center justify-between text-sm" data-id="element-43">
                      <div className="flex items-center gap-2" data-id="element-44">
                        <div className="w-3 h-3 rounded-full bg-[#FF6B35]" data-id="element-45" />
                        <span className="text-slate-600" data-id="element-46">Digital Wellness</span>
                      </div>
                      <span className="font-medium text-slate-900" data-id="element-47">35%</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Card>
        </motion.div>
      </div>
    </section>;
}